<template>
	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="i">
				<div >
					<div v-if="i === 'content'" class="form-group">
						<label>{{ i }}</label>	
						<textarea rows="5" class="form-control" :id="`${i}image-and-body-copy${index}`" v-model="componentItem.content[i]"></textarea>
					</div>
					<div v-else-if="i === 'background-image'">
						<BackgroundImage :backgroundImage="componentItem.content[i]" :forTemplate="componentItem.template"/>
					</div>
					<div v-else-if="typeof content !== 'object'" class="form-group col-md-6">
						<label>{{ i }}</label>
						<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					</div>
				</div>
			</div>
		</template>
		<OptionalObjectField 
			:componentItemContent="componentItem.content" 
			:componentItemKey="'citation'" 
			:componentItemSampleContent="sampleContent['citation']"
			:forTemplate="componentItem.template" 
		>
		</OptionalObjectField>
		<ForegroundAudio 
            :componentItemContent="componentItem.content" 
            :componentItemSampleContent="sampleContent['foreground-audio']"
        />
		<BackgroundVideo :componentItemContent="componentItem.content" />
		<BackgroundAudio :componentItemContent="componentItem.content" />
	</div>
</template>

<script>
	import BackgroundImage from '../BackgroundImage';
	import BackgroundVideo from '../BackgroundVideo';
	import BackgroundAudio from '../BackgroundAudio';
	import ForegroundAudio from '../ForegroundAudio.vue'
	import OptionalObjectField from '../OptionalObjectField.vue';

	export default {

		components: {
			BackgroundImage,
			BackgroundVideo,
			BackgroundAudio,
			ForegroundAudio,
			OptionalObjectField
		},		
		
		name: 'AcastQuote',
		
		props: ['componentItem', 'index', 'sampleContent'],

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>